import React from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './simulatedUploadConfirmationModalMessages';

function getMessage(error) {
  switch (true) {
    case /^12$/g.test(error):
      return messages.errorAnswersheetNotMatchEvaluation;
    case /^11$/g.test(error):
      return messages.defaultFriendlyErrorMessage;
    case /^10$/g.test(error):
      return messages.defaultFriendlyErrorMessage;
    case /^5$/g.test(error):
      return messages.alreadyCorrected;
    case /^4$/g.test(error):
      return messages.errorStudentNotFound;
    case /^3$/g.test(error):
      return messages.errorFileNotSupported;
    case /^2$/g.test(error):
      return messages.errorPermissionDenied;
    case /^SM001$/g.test(error):
      return messages.SM001;
    case /^SM0002$/g.test(error):
      return messages.SM0002;
    case /^SM0003$/g.test(error):
      return messages.SM0003;
    case /^SM0004$/g.test(error):
      return messages.SM0004;
    case /^SM0005$/g.test(error):
      return messages.SM0005;
    case /^SM0006$/g.test(error):
      return messages.SM0006;
    case /^SM0007$/g.test(error):
      return messages.SM0007;
    case /^SM0008$/g.test(error):
      return messages.SM0008;
    case /^SM0009$/g.test(error):
      return messages.SM0009;
    case /^SM0010$/g.test(error):
      return messages.SM0010;
    case /^SM0011$/g.test(error):
      return messages.SM0011;
    case /^SM0018$/g.test(error):
      return messages.SM0018;
    default:
      return messages.errorGeneric;
  }
}

function SimulatedUploadConfirmationModal({
  isOpen,
  singularFile,
  onClose,
  intl,
  onBack,
  onContinue,
  ...props
}) {
  const message = getMessage(props.errCode);
  const subtitleMessage = props.amount > 1 ? messages.pluralSubtitle : messages.singularSubtitle;
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      icon={props.error.length > 0 ? 'ti-thumb-down' : 'ti-thumb-up'}
      title={intl.formatMessage(messages.title)}
      subtitle={
        props.error.length > 0
          ? intl.formatMessage(message)
          : intl.formatMessage(subtitleMessage, { amount: props.amount })
      }
      buttons={[
        {
          label: intl.formatMessage(messages.close),
          onClick: onContinue,
          primary: true,
        },
      ]}
      small
    />
  );
}

SimulatedUploadConfirmationModal.defaultProps = {
  amount: 1,
};

export default injectIntl(SimulatedUploadConfirmationModal);
